import { CARGAR_CATALOGOCUENTAS, CARGAR_CTACONTABLE, CARGAR_PLANESCONTABLES, ESTABLECER_CTACONTABLE } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';
import global_axios from '../../funciones_globales/interaccionapi';

export const cargar_CuentasbyPlanContable = (idPlanContable) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/planescontables/${idPlanContable}/cuentas`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {
			let cuentasCtbles = response.data;		
			dispatch({
				type: CARGAR_CATALOGOCUENTAS,
				data: cuentasCtbles
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar catálogo de cuentas contables.', mensaje: msgError}
			});
		});
	}
}

export const inicializar_Cuentas = () =>{
	return {
		type: CARGAR_CATALOGOCUENTAS,
		data: []
	}
}

export const cargar_CuentaContable = (idPlanContable, codCuenta) => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/cuentas/${codCuenta}/${idPlanContable}`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {		
			dispatch({
				type: CARGAR_CTACONTABLE,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar cuenta contable.', mensaje: msgError}
			});
		});
	}
}

export const cargar_PlanesContables = () => {
	return (dispatch) => {
		let config_request = {
			method: 'GET',
			url: `/planescontables`
		}
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios(config_request)
		.then( response => {		
			dispatch({
				type: CARGAR_PLANESCONTABLES,
				data: response.data
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
		})
		.catch((error)=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar planes contables.', mensaje: msgError}
			});
		});
	}
}

export const seleccionar_CuentaContable = (ctaContable) => ({
	type: ESTABLECER_CTACONTABLE,
	data: ctaContable
});